//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"DetailLevel",1,0],[0,"FabricationNumbering",1,0],[0,"IncludeComponents",1,0],[0,"IncludeGaskNutBolts",1,0],[0,"IncludeOverStock",1,0],[0,"IncludeStock",1,0],[0,"IncludeWireStock",1,0],[0,"StockLength",1,0],[0,"StockPieceCount",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.BillOfMaterialBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.BillOfMaterialBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.BillOfMaterialBuilder.DetailLevelType = Object.freeze({
    "Summary" : "Summary", "Itemized" : "Itemized"});

SPLM.Annotations.BillOfMaterialBuilder.FabricationNumberingType = Object.freeze({
    "Sequential" : "Sequential", "Original" : "Original"});

SPLM.Annotations.BillOfMaterialBuilder.StockLengthType = Object.freeze({
    "SingleSum" : "SingleSum", "ListEach" : "ListEach"});

export default SPLM;